import { render, staticRenderFns } from "./WiensLawViz.vue?vue&type=template&id=6a89d51a&scoped=true"
import script from "./WiensLawViz.vue?vue&type=script&lang=js"
export * from "./WiensLawViz.vue?vue&type=script&lang=js"
import style0 from "./WiensLawViz.vue?vue&type=style&index=0&id=6a89d51a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89d51a",
  null
  
)

export default component.exports